export default __webpack_public_path__ + "static/media/mon_24.d995d30e.png";